import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { provide } from 'ember-provide-consume-context';
import { CardContextName, DefaultFormatsContextName, ResolvedCodeRef } from '@cardstack/runtime-common';
import type { BaseDef, Format, Field } from 'https://cardstack.com/base/card-api';
import PrerenderedCardSearch from './prerendered-card-search';
interface Signature {
    Element: any;
    Args: {
        card: BaseDef;
        format?: Format;
        field?: Field;
        codeRef?: ResolvedCodeRef;
        cardContext?: Record<string, any>;
        displayContainer?: boolean;
    };
}
export default class Preview extends Component<Signature> {
    @provide(DefaultFormatsContextName)
    get defaultFormat() {
        let { format: format1 } = this.args;
        format1 = format1 ?? 'isolated';
        return {
            cardDef: format1,
            fieldDef: format1
        };
    }
    @provide(CardContextName)
    private get context() {
        return {
            prerenderedCardSearchComponent: PrerenderedCardSearch,
            ...this.args.cardContext
        };
    }
    static{
        template(`
    <this.renderedCard @displayContainer={{@displayContainer}} ...attributes />
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    get renderedCard() {
        return this.args.card.constructor.getComponent(this.args.card, this.args.field, this.args.codeRef ? {
            componentCodeRef: this.args.codeRef
        } : undefined);
    }
}
